<div class="row mt-2 no-gutters">
    <div class="col">
        <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']"
                class="text-secondary">Developer Portal</a>
            /<a [routerLink]="['/faq']" class="text-secondary"> FAQ</a></small>
        <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
                class="text-secondary" (click)="onCloseFaqs()">Developer Portal</a>
            /<a [routerLink]="['/faq']" class="text-secondary"> FAQ</a></small>
        <small *ngIf="accountType== 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']"
                class="text-secondary" (click)="onCloseFaqs()">Developer Portal</a>
            /<a [routerLink]="['/faq']" class="text-secondary"> FAQ</a></small>
    </div>
</div>
<div class="row mt-3 mb-2">
    <div class="col-xl-2 col-lg-2 col-md-2 col-3 pr-0">
        <!-- <div class="header-medium pb-2 pointer" (click)="openSectionDetail(faqAndOverview[0])">
            <div class="pb-3 pointer">
                <span
                    [ngClass]="selectedSectionDetail && selectedSectionDetail.name == faqAndOverview[0].name ? 'selected-section-border pb-1' : ''">
                    {{faqAndOverview[0].name}}
                </span>
            </div>
        </div> -->
        <div *ngFor="let faqAndOverviewObject of faqAndOverview.slice(1); let i = index">
            <!-- <div class="header-medium pointer" (click)="openSectionDetail(faqAndOverviewObject.sections[0])"> -->
            <div class="header-medium">
                {{faqAndOverviewObject.name}}
            </div>
            <div class="font13-400 py-3 pointer" *ngFor="let section of faqAndOverviewObject.sections; let i = index"
                (click)="openSectionDetail(section)">
                <span
                    [ngClass]="selectedSectionDetail && selectedSectionDetail.name == section.name ? 'selected-section-border pb-1' : ''">
                    {{section.name}}
                </span>
            </div>
        </div>
    </div>
    <div class="col-xl-10 col-lg-10 col-md-10 col-9 mt-3">
        <app-faq-detail [selectedSectionDetail]="selectedSectionDetail"></app-faq-detail>
    </div>
</div>